const LeadDetailClick = (($) => {
    $(document).ready(function () {
        $('.table__row--hover').on('click', function (event) {
            event.preventDefault();
            let href = $(this).find('a.product').attr('href');
            if (href) {
                window.open(href);
            }
        });
    });
})(jQuery);

// export default LeadDetailClick
